module.exports = __webpack_public_path__ + "static/media/招标代理5A资信@3x.149c92e3.png";